/* Curated First Product Script */
(function() {
  // Get URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const firstParam = urlParams.get('first');
  
  if (!firstParam) return;
  
  // Parse product handle
  let productHandle = '';
  if (firstParam.startsWith('http')) {
    try {
      const url = new URL(firstParam);
      const pathParts = url.pathname.split('/').filter(Boolean);
      if (pathParts[0] === 'products' && pathParts[1]) {
        productHandle = pathParts[1];
      }
    } catch(e) {
      return;
    }
  } else {
    productHandle = firstParam;
  }
  
  if (!productHandle) return;
  
  const variantId = urlParams.get('variant');
  
  // Wait for page to fully load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    const grid = document.querySelector('.collection .product-grid, [id*="product-grid"], .collection ul, main ul');
    if (!grid) return;
    
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        const existingCard = grid.querySelector('.card, .product-card, li');
        if (!existingCard) return;
        
        const newCard = existingCard.cloneNode(true);
        
        // Update all links
        const links = newCard.querySelectorAll('a');
        links.forEach(link => {
          link.href = `/products/${product.handle}`;
          if (variantId) link.href += `?variant=${variantId}`;
        });
        
        // Update ALL images
        const images = newCard.querySelectorAll('img');
        images.forEach(img => {
          if (product.featured_image) {
            img.src = product.featured_image;
            img.srcset = '';
            img.alt = product.title;
            if (img.dataset.src) img.dataset.src = product.featured_image;
            if (img.dataset.srcset) img.dataset.srcset = '';
          }
        });
        
        // Update title - try multiple selectors
        const titleSelectors = [
          '.card__heading',
          '.product__title', 
          '.card-information__text h3',
          '.card-information__text',
          'h3',
          'h2',
          'a[href*="/products/"]'
        ];
        
        for (let selector of titleSelectors) {
          const elements = newCard.querySelectorAll(selector);
          elements.forEach(el => {
            if (el.textContent && el.textContent.trim().length > 0 && !el.querySelector('img')) {
              el.textContent = product.title;
            }
          });
        }
        
        // Update price
        const priceElements = newCard.querySelectorAll('.price, .product__price, [class*="price"]');
        if (priceElements.length > 0 && product.price) {
          const formatted = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(product.price / 100);
          
          priceElements.forEach(el => {
            if (el.textContent.includes('$')) {
              el.textContent = formatted;
            }
          });
        }
        
        grid.insertBefore(newCard, grid.firstChild);
      })
      .catch(error => console.error('Error:', error));
  }
})();